import { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { ComponenteSolucaoOffGrid, ListagemItem } from "../../types";
import { notifierStore } from "src/framework/store/NotifierStore";

interface CalcularAcessoriosInput {
  moduloId: number;
  regioes: number[]
  quantidade_modulos: number;
  inversores: ComponenteSolucaoOffGrid[]
  controladores: ComponenteSolucaoOffGrid[]
}

const projetosProvider = new ProjetosProvider();

export const calcularAcessorios = async ({ controladores, inversores, moduloId, regioes, quantidade_modulos }: CalcularAcessoriosInput): Promise<IDataResponse<ListagemItem[]>> => {
  const calculoAcessoriosResponse = await projetosProvider.calcularAcessorios(moduloId, {
    regiao_id: regioes,
    quantidade_modulos: quantidade_modulos,
    segmento: 'off',
    inversores: (inversores || []).length > 0 ? inversores.map(item => ({
      categoria_componentes_id: item.categoria_componentes_id,
      id: item.id,
      quantidade: item.quantidade,
    }) ) : [],
    controladores: (controladores || []).length > 0 ? controladores.map(item => ({
      categoria_componentes_id: item.categoria_componentes_id,
      id: item.id,
      quantidade: item.quantidade,
    }) ) : [],
  })

  if (calculoAcessoriosResponse.statusCode !== STATUS_CODE.OK) {
    notifierStore.setNotifier({
        content: [
          "Alguns itens não estão disponíveis para cálculo.",
          "Sugestão:",
          "- Altere os parâmetros de dimensionamento do seu gerador; ou",
          "- Entre em contato com seu atendimento comercial de Off Grid."
        ],
        onClose: () => notifierStore.setOpen(false),
        timeOut: 4000,
        title: "Atenção"
    })

    notifierStore.setOpen(true)
    return {
      ...calculoAcessoriosResponse,
      data: [],
    };
  }

  return {
    ...calculoAcessoriosResponse,
    data: calculoAcessoriosResponse.data.map(item => {
      return {
        altura: Number(item.altura || 0),
        categoria_componentes_id: Number(item.categoria_componentes_id || 0),
        componente_id: Number(item.id || 0),
        descricao: String(item.descricao || ''),
        largura: Number(item.largura || 0),
        nome: item.nome_componente,
        peso: Number(item.peso || 0),
        potencia: 0,
        quantidade: item.quantidade ?? 0,
        quantidade_original: item.quantidade ?? 0,
        valor: 0,
        valor_unitario: 0,
        exibir_popup_parceiro: false,
      }
    })
  }
}